import Text from './Text';
import Br from './Br';

export {
  Br,
  Text
}

export default Text;
